import { useLayoutEffect, useReducer, useRef } from 'react';
import { callSessionReducer, initialCallSessionState } from '../callSessionReducer';

/**
 * Call placement + lifecycle flags with refs mirrored for hooks that still read `.current` synchronously.
 */
export function useCallSession() {
  const [session, dispatch] = useReducer(callSessionReducer, initialCallSessionState);

  const hasConnectedRef = useRef(false);
  const hadLiveCallRef = useRef(false);

  useLayoutEffect(() => {
    hasConnectedRef.current = session.hasConnected;
    hadLiveCallRef.current = session.hadLiveCall;
  }, [session.hasConnected, session.hadLiveCall]);

  return {
    session,
    dispatch,
    hasConnectedRef,
    hadLiveCallRef,
  };
}
